import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m20.983 11.154 1.202-.933a.916.916 0 0 0-.104-1.518L9.523 1.47a3.64 3.64 0 0 0-2.808-.323 3.64 3.64 0 0 0-2.202 1.771l-.774 1.422c-.948 1.742-.316 3.957 1.399 4.934l5.186 3.023-1.108 3.324a2.75 2.75 0 0 1-2.609 1.88H3.292v-2.75a.917.917 0 0 0-1.833 0v7.333a.917.917 0 0 0 1.833 0v-2.75h3.315a4.58 4.58 0 0 0 4.347-3.133l.988-2.96 2.637 1.538a3.65 3.65 0 0 0 2.817.34 3.7 3.7 0 0 0 .918-.4l1.459.81c.542.3 1.224.101 1.521-.443l.774-1.417a1.116 1.116 0 0 0-.44-1.512l-1.041-.577a1.8 1.8 0 0 1 .395-.423zm-4.088 2.2a1.82 1.82 0 0 1-1.4-.165L6.053 7.684a1.844 1.844 0 0 1-.704-2.47l.773-1.422a1.82 1.82 0 0 1 1.102-.885q.256-.073.514-.073c.307 0 .61.077.88.229L19.982 9.61l-.124.096c-.402.31-.728.695-.972 1.141l-.885 1.623c-.237.435-.63.748-1.107.884"
    }, null, -1)
  ]))]))
}
export default { render: render }